// Simple product form fix that keeps native Dawn functionality
// but shows "Added!" feedback without redirecting to cart
// Add CSS for the success state
const style = document.createElement('style');
style.textContent = `
  .product-form__submit.success {
    background-color: #009900 !important; 
    transition: background-color 0.3s ease;
  }
`;
document.head.appendChild(style);

if (!customElements.get('fixed-product-form')) {
  customElements.define(
    'fixed-product-form',
    class FixedProductForm extends HTMLElement {
      constructor() {
        super();
        
        this.form = this.querySelector('form');
        if (!this.form) return;
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.loadingSpinner = this.querySelector('.loading__spinner');
        
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.loadingSpinner?.classList.remove('hidden');

        const config = {
          method: 'POST',
          headers: { 
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        };

        const formData = new FormData(this.form);
        
        // Add sections for cart drawer
        if (this.cart) {
          try {
            const sections = this.cart.getSectionsToRender().map(section => section.id);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
            
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (e) {
            console.error('Error preparing cart sections:', e);
          }
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error handling
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              return;
            }
            
            // Success - just update cart contents without opening drawer
            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }

            // Emit custom event for UX enhancements
            const addedEvent = new CustomEvent('cart:added', {
              detail: {
                product: response.product_title || response.title,
                quantity: response.quantity || 1,
                variant: response.variant_id,
                response: response
              },
              bubbles: true
            });
            this.dispatchEvent(addedEvent);

            // Also emit cart updated event - THIS IS CRITICAL FOR CART-UPDATE-WATCHER.JS
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));

            // Update button to show success
            this.submitButton.classList.add('success');
            if (this.submitButtonText) {
              const originalText = this.submitButtonText.textContent;
              this.submitButtonText.textContent = 'Added!';
              
              // Reset after timeout
              setTimeout(() => {
                this.submitButton.classList.remove('success');
                this.submitButtonText.textContent = originalText;
              }, 10000);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('An error occurred. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.loadingSpinner?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        if (!errorWrapper) return;
        
        const errorElement = errorWrapper.querySelector('.product-form__error-message');
        if (!errorElement) return;

        errorWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          errorElement.textContent = errorMessage;
        }
      }
    }
  );
}

